module.exports = __webpack_public_path__ + "Server-Default.None.6fc5ab815b9f124c7db3a12d581ea482.hashedasset.svg";